import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';
import InvoiceEditor from './InvoiceEditor';

const defaultValidationErrorMessage = 'Invalid input. Enter a different value.';

class InvoiceEditorSlidingPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      disableSaveButton: true,
      invoiceData: props.invoiceData,
      backupInvoiceData: props.invoiceData,
      invoiceNumber: props.invoiceData.invoice,
      fieldsTouched: {}
    };
  } 

  componentWillReceiveProps = nextProps => {
    if (this.props.invoiceData !== nextProps.invoiceData) {
      this.setState({
        invoiceData: nextProps.invoiceData,
        backupInvoiceData: nextProps.invoiceData
      });
    }
  };

  saveInvoiceData = invoiceData => {
    this.setState({ 
      disableSaveButton: true
    });
    axios
      .put(`utm/v1/transactions`, invoiceData)
      .then(() => {
        this.props.invoicesActions.fetchInvoiceById(this.props.invoice.id);
        this.props.onClose();
      })
      .catch(err => { throw err; });
  };

  onCloseSlidingPanel = () => {
    this.setState({ 
      disableSaveButton: true,
      invoiceData: this.state.backupInvoiceData
    });
    this.props.onClose();
  };

  handleCheckInputError = () => {
    const inputErrorMessages = Object.values(this.state.fieldsTouched);
    this.setState({
      disableSaveButton: inputErrorMessages.includes(defaultValidationErrorMessage)
    });
  }

  handleInputChange = (name, value, errorMessage) => {
    this.setState( oldState => ({
      invoiceData: { ...oldState.invoiceData, [name]: value },
      fieldsTouched: {...oldState.fieldsTouched, [name]: errorMessage }
    }),  () => this.handleCheckInputError()
    );
  };

  handleSaveButtonClick = () => this.saveInvoiceData(this.state.invoiceData);

  render () {
    const { open } = this.props;
    const {
      disableSaveButton,
      invoiceData,
      invoiceNumber
    } = this.state;
    return (
      <SovosEditableSlidingPanel
        open={ open }
        onClose={ this.onCloseSlidingPanel }
        isDirty={ () => true }
        baseWidth={ '1230px' }
        title={ `Invoice ${ invoiceNumber }` }
        dialogTitle={ SLIDING_PANEL_DIALOG_TITLE }
        dialogText={ SLIDING_PANEL_DIALOG_TEXT }
        dialogContentClassName={ SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME }
        dialogActionLabel={ SLIDING_PANEL_DIALOG_ACTION_LABEL }
        SaveButtonProps={ {
          onClick: this.handleSaveButtonClick,
          disabled: disableSaveButton,
          children: 'SAVE'
        } }
        CancelButtonProps={ {
          children: 'CANCEL'
        } }
        CloseDialogProps={ {
          DialogTitleProps: {
            children: SLIDING_PANEL_DIALOG_TITLE,
            className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
          },
          DialogContentProps: {
            children: SLIDING_PANEL_DIALOG_TEXT,
            className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
          },
          OKButtonProps: {
            children: SLIDING_PANEL_DIALOG_ACTION_LABEL
          },
          CancelButtonProps: {
            children: 'CANCEL'
          }
        } }
      >
        <InvoiceEditor 
          onFieldChange={ this.handleInputChange }
          invoice={ invoiceData }
        />
      </SovosEditableSlidingPanel>
    );
  }
}

InvoiceEditorSlidingPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  invoiceData: PropTypes.object,
  invoice: PropTypes.object,
  invoicesActions: PropTypes.shape({
    fetchInvoiceById: PropTypes.func
  })
};

export default InvoiceEditorSlidingPanel;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceEditor/InvoiceEditorSlidingPanel.js